import { render, staticRenderFns } from "./damagedItems.pug?vue&type=template&id=f1199cc4&lang=pug&external"
import script from "./damagedItems.js?vue&type=script&lang=js&external"
export * from "./damagedItems.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/luis.rodriguez/Documents/Multiasistencia/selfcarefront/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1199cc4')) {
      api.createRecord('f1199cc4', component.options)
    } else {
      api.reload('f1199cc4', component.options)
    }
    module.hot.accept("./damagedItems.pug?vue&type=template&id=f1199cc4&lang=pug&external", function () {
      api.rerender('f1199cc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/Damage/views/damagedItems/index.vue"
export default component.exports